import axios from 'axios';
import { getSessionCookie, setSessionCookie } from './session';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
});

const tenantId = window.location.host.split(':')[0].split('.')[0];

const request = async (endpoint, obj, method, contentType) => {
  const promise = new Promise((resolve, reject) => {
    const session = getSessionCookie();
    if (session != null && session?.accessToken) {
      const now = new Date();
      if (!session || (new Date(session.expiration)) < now) {
        setSessionCookie(null);
        window.location.reload();
        resolve(null);
      }
    }
    const success = (result => {
      var newResult = {
        status: result.status,
        message: result.message,
        data: result.data
      }

      resolve(newResult);
    });
    const failed = (error => {
      if (error.response) {
        if (error.response.status === 401 || error.response.status === 403)
          reject({ status: error.response.status, message: "Sua sessão expirou. Realize o acesso novamente" });
        else
          try {
            reject({ status: error.response.status, message: error.response.data ? error.response.data.message : error.response.message, data: error.response.data });
          }
          catch {
            reject({ status: 500, message: "Erro ao conectar com API" });
          }
      }
      else {
        reject({ status: 500, message: "Erro ao conectar com API" });
      }
    })
    const headers = () => {
      const _headers = {
        headers: {
          'tenantId': tenantId,
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': '0',
        }
      };

      if (contentType == "multipart/form-data")
      {
        _headers.headers["Mime-Type"] = "multipart/form-data";
        delete _headers.headers['Content-Type'];
      }
      else { 
        _headers.headers['Content-Type'] = contentType;
      }
      if (session != null && session?.accessToken)
        _headers.headers.Authorization = `Bearer ${session.accessToken}`
      return _headers;
    }

    try {
      if (method == "POST")
        return api.post(endpoint, contentType == "multipart/form-data" ? obj : JSON.stringify(obj), headers())
          .then(result => success(result))
          .catch(error => failed(error));
      else if (method == "PUT")
        return api.put(endpoint, contentType == "multipart/form-data" ? obj : JSON.stringify(obj), headers())
          .then(result => success(result))
          .catch(error => failed(error));
      else if (method == "GET")
        return api.get(endpoint, headers())
          .then(result => success(result))
          .catch(error => failed(error));
      else if (method == "DELETE")
        return api.delete(endpoint, headers())
          .then(result => success(result))
          .catch(error => failed(error));

    }
    catch (error) {
      var result = {
        status: 500,
        message: "Erro no servidor (500)"
      }
      resolve(result);
    }
  });

  return promise;
};

const api_POST = (endpoint, obj) => {
  return new Promise((resolve, reject) => {
    request(endpoint, obj, "POST", 'application/json')
      .then(result => resolve(result))
      .catch(error => reject(error));
  });
};

const api_POST_File = (endpoint, obj) => {
  return new Promise((resolve, reject) => {
    request(endpoint, obj, "POST", 'multipart/form-data')
      .then(result => resolve(result))
      .catch(error => reject(error));
  });
};

const api_PUT = (endpoint, obj) => {
  return new Promise((resolve, reject) => {
    request(endpoint, obj, "PUT", 'application/json')
      .then(result => resolve(result))
      .catch(error => reject(error));
  });
};

const api_DELETE = (endpoint, obj) => {
  return new Promise((resolve, reject) => {
    request(endpoint, obj, "DELETE", 'application/json')
      .then(result => resolve(result))
      .catch(error => reject(error));
  });
};

const api_GET = (endpoint) => {
  return new Promise((resolve, reject) => {
    request(endpoint, null, "GET", 'application/json')
      .then(result => resolve(result))
      .catch(error => reject(error));
  });
};

const api_GETExternal = (endpoint) => {
  const promise = new Promise((resolve, reject) => {
    try {
      return axios.get(endpoint)
        .then(result => {
          let newResult = {
            status: result.status,
            data: result.data,
            headers: result.headers
          }
          resolve(newResult);
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 401 || error.response.status === 403) {
              window.location.reload();
              return;
            }

            let message = "";
            if (error.response.data.message)
              message = error.response.data.message;
            else
              message = "Erro inesperado";

            let newError = {
              status: error.response.data.status,
              message: message
            }
            resolve(newError);
          }
          else {
            let result = {
              status: 500,
              message: "Erro ao conectar com a api."
            }
            resolve(result);
          }
        });

    } catch (error) {
      let result = {
        status: 500,
        message: "Erro no servidor."
      }
      resolve(result);
    }
  });
  return promise;
};

export { api_POST, api_PUT, api_DELETE, api_GET, api_GETExternal, api_POST_File };